module.exports = __webpack_public_path__ + "img/3_4_1.6579eaa8.jpg";